import React, { useState, useEffect } from "react"
import Flink from '~/components/shared/flink'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import QuickCaption from './quick-caption'
import BlogPdp from '~/components/testing/blog-pdp'

import * as styles from "~/styles/blog/img-cols.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const ImgCols = ({ blockId, index }) => {
  const { post, props } = usePost()
  const { quickProds } = props
  const blogTitle = post.title
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  const [teston, setTeston] = useState(false)
  const [istest, setIstest] = useState(false)

  const images = []

  if ( notBlank(settings.img1_img) ) {
    const obj = {
      type: 'image1',
      image: imgSize(settings.img1_img,900),
      scale: parseInt(settings.img1_scale),
      smaller: parseInt(settings.img1_scale) < parseInt(settings.img2_scale),
      link: notBlank(settings.img1_link) ? settings.img1_link : false,
      credit: settings.img1_credit,
      title: notBlank(settings.img1_title) ? settings.img1_title : false,
      copy: notBlank(settings.img1_copy) ? settings.img1_copy : false,
      cta: notBlank(settings.img1_cta) ? settings.img1_cta : false,
      align: notBlank(settings.img1_align) ? settings.img1_align : false
    }
    images.push(obj)
  }
  if ( notBlank(settings.img2_img) || notBlank(settings.img2_copy) ) {
    const obj = {
      type: 'image2',
      image: settings.img2_img ? imgSize(settings.img2_img,900) : false,
      scale: parseInt(settings.img2_scale),
      smaller: parseInt(settings.img2_scale) < parseInt(settings.img1_scale),
      link: notBlank(settings.img2_link) ? settings.img2_link : false,
      credit: settings.img2_credit,
      title: notBlank(settings.img2_title) ? settings.img2_title : false,
      copy: notBlank(settings.img2_copy) ? settings.img2_copy : false,
      cta: notBlank(settings.img2_cta) ? settings.img2_cta : false,
      align: notBlank(settings.img2_align) ? settings.img2_align : false
    }
    images.push(obj)
  }

  if ( notBlank(settings.img3_img) ) {
    const obj = {
      type: 'image3',
      image: imgSize(settings.img3_img,900),
      scale: parseInt(settings.img3_scale),
      smaller: parseInt(settings.img3_scale) < parseInt(settings.img1_scale),
      link: notBlank(settings.img3_link) ? settings.img3_link : false,
      credit: settings.img3_credit,
      title: notBlank(settings.img3_title) ? settings.img3_title : false,
      copy: notBlank(settings.img3_copy) ? settings.img3_copy : false,
      cta: notBlank(settings.img3_cta) ? settings.img3_cta : false,
      align: notBlank(settings.img3_align) ? settings.img3_align : false
    }
    images.push(obj)
  }

  let classes = []
  if (settings.no_margin) classes.push(styles.no_margin)
  const same_size = parseInt(settings.img1_scale) === parseInt(settings.img2_scale) 
  if (same_size) classes.push(styles.same_size)
  if (images.length > 2) classes.push(styles.nd_tre)
  if (images.length === 1) classes.push(styles.nd_solo)
  // if (settings.no_gap)
  if (true) classes.push(styles.no_gap)
  classes = classes.join(' ')
  

  const checkTesto = (tindex) => {
    if (!istest) return true
    if (block.id !== 2495) return true
    if (tindex !== 0) return true

    return !teston
  }

  useEffect(() => {
    setTimeout(() => {if (localStorage.getItem('csearch')) setIstest(true)}, 300)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <div 
      className={jnstyls([bstyle.sec, styles.img_cols, classes])}
      block={block.id}
    >
      {images.map( (item, tindex) =>
        <React.Fragment key={`two_${index}${tindex}`}>
          <style>
            {`@media only screen and (min-width: 800px) {
              .imgcols_${block.id}${tindex} .${styles.image},
              .imgcols_${block.id}${tindex} .${styles.caption} {
                width: ${item.scale}%;
              }
            }`}
          </style>

          <div 
            className={jnstyls([styles.item, `imgcols_${block.id}${tindex}`, item.smaller ? styles.smaller : ''])}
          > 
            {(notBlank(item.title) && item.title_above) && (
              <div className={styles.title_wr}>
                {item.link ? (
                  <div className={jnstyls([bstyle.title, styles.title])}>
                    <Flink 
                      href={item.link} 
                      className={bstyle.title_link} 
                      aria-label={item.title} 
                      dangerouslySetInnerHTML={{ __html: item.title }} 
                    />
                  </div>
                ) : (
                  <div className={jnstyls([bstyle.title, styles.title])} dangerouslySetInnerHTML={{ __html: item.title }} />
                )}
              </div>
            )}
            <div 
              className={jnstyls([styles.image, item.credit ? bstyle.image_credit : ''])} 
            > 
              {(item.image && checkTesto(tindex)) && (
                <>
                  {item.link ? (
                    <Flink href={item.link} className="">
                      <img 
                        className={styles.img}
                        src={item.image}
                        alt={notBlank(item.credit) ? item.credit : notBlank(item.title) ? `${item.title} ${tindex}` : `${blogTitle} two images - ${tindex + 1}`} 
                        width={450} height={600} 
                      />
                    </Flink>
                  ) : (
                    <img 
                      className={styles.img}
                      src={item.image}
                      alt={notBlank(item.credit) ? item.credit : notBlank(item.title) ? `${item.title} ${tindex}` : `${blogTitle} two images - ${tindex + 1}`} 
                      width={450} height={600} 
                    />
                  )}
                  {item.credit && (
                    <div className={bstyle.credit}>{item.credit}</div>
                  )}
                </>
              )}
              {(block.id === 2495 && tindex === 0 && istest) && (
                <BlogPdp teston={teston} setTeston={setTeston} />
              )}
            </div>

            {checkTesto(tindex) && (notBlank(item.title) || notBlank(item.copy) || notBlank(item.cta)) && (
              <div 
                className={jnstyls([styles.caption, item.align !== 'left' ? styles[`caption_a${item.align}`] : ''])} 
              >
                {item.title && (
                  <>
                    {item.link ? (
                      <div className={jnstyls([bstyle.title, styles.title])}>
                        <Flink 
                          href={item.link} 
                          className={bstyle.title_link} 
                          aria-label={item.title} 
                          dangerouslySetInnerHTML={{ __html: item.title }} 
                        />
                      </div>
                    ) : (
                      <div className={jnstyls([bstyle.title, styles.title])} dangerouslySetInnerHTML={{ __html: item.title }} />
                    )}
                  </>
                )}
                {item.copy && (
                  <>
                    {(quickProds && item.copy?.includes('/products/') && !!quickProds.length) ? (
                      <QuickCaption 
                        copy={item.copy} 
                        styles={styles.copy_body}
                      />
                    ) : (
                      <div className={styles.copy_body} dangerouslySetInnerHTML={{ __html: item.copy }} />
                    )}
                  </>
                )}
                {(item.cta && item.link) && (
                  <div className={styles.copy_cta}>
                    <Flink href={item.link} className={bstyle.cta_link}><span>{item.cta}</span></Flink>
                  </div>
                )}
              </div>
            )}

          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default ImgCols